import { Guid, SerializableObject } from '../../common-react/core';

import { LocationType } from '../other/location-type.enum';

import { Address } from './address.do';


export class UserProfile extends SerializableObject {
  public userId: Guid;
  public name?: string;
  public email?: string;
  public emailVerified?: boolean;
  public phoneNumber?: string;
  public phoneNumberVerified?: boolean;
  public identificationNumber?: string;
  public identificationNumberVerified?: boolean;
  public language?: string;
  public preferredDeliveryMethod: LocationType;
  public preferredDeliveryMethodLocationId: Guid;
  public paymentCardId?: string;
  public permissionToMakeAutomaticPayments: boolean;
  public currentAddress: Address;
  public preferredAddress?: Address;
  public parcelAddress?: Address;
  public hasPassword: boolean;
  public hasAgreedToGdprTerms: boolean;

  public hasPendingVerification(): boolean {
    return !this.identificationNumberVerified || !this.phoneNumberVerified || !this.emailVerified;
  }

  protected coercePropertyType(propertyName: string, propertyValue: unknown): unknown {
    const returnValue: unknown = super.coercePropertyType(propertyName, propertyValue);

    switch (propertyName) {
      case 'paymentCardId':
        return propertyValue === '' || propertyValue === null ? undefined : propertyValue;

      default:
        return returnValue;
    }
  }
}
